/* 11/04/2021 ADDED FILTER FOR PO TYPES */
import { https, httpsFile } from './http.js';
export function index(data, page, currentpage, fromMyPO = false) {
    return httpsFile().get(`temporary-po-header?page=${page}&currentpage=${currentpage}&date_from=${data.dateFrom}
    &date_to=${data.dateTo}&vendor_from=${data.supplierFrom}&vendor_to=${data.supplierTo}&company=${data.company}&status=${data.status}
    &user=${data.user}&approver=${data.approver}&po_number=${data.po_number}&matnr=${data.materialno}&type=ALL&fromMyPO=${fromMyPO}`);
}

export function getListPoImportation(data, page, currentpage) {
    return httpsFile().get(`getListPoImportation?page=${page}&currentpage=${currentpage}&date_from=${data.dateFrom}
    &date_to=${data.dateTo}&vendor_from=${data.supplierFrom}&vendor_to=${data.supplierTo}&company=${data.company}&status=${data.status}
    &user=${data.user}&approver=${data.approver}&po_number=${data.po_number}&matnr=${data.materialno}&type=ALL`);
}

export function getPIList(data, page, currentpage) {
    let search = data.po_number;
    let vSearch = search.replace('#','');
    return httpsFile().get(`getPIList?page=${page}&currentpage=${currentpage}&date_from=${data.dateFrom}
    &date_to=${data.dateTo}&vendor_from=${data.supplierFrom}&vendor_to=${data.supplierTo}&company=${data.company}&status=${data.status}
    &user=${data.user}&approver=${data.approver}&po_number=${vSearch}&matnr=${data.materialno}&type=ALL&is_completed=${data.is_completed}
    &type=ALL&po_status=${data.po_status}`);
}

export function getPIListExport(data, page, currentpage) {
    let search = data.po_number;
    let vSearch = search.replace('#','');
    return httpsFile().get(`getPIListExport?page=${page}&currentpage=${currentpage}&date_from=${data.dateFrom}
    &date_to=${data.dateTo}&vendor_from=${data.supplierFrom}&vendor_to=${data.supplierTo}&company=${data.company}&status=${data.status}
    &user=${data.user}&approver=${data.approver}&po_number=${vSearch}&matnr=${data.materialno}&type=ALL&is_completed=${data.is_completed}
    &type=ALL&po_status=${data.po_status}`);
}

export function getForApprovalListPoImportation(data, page, currentpage) {
    return httpsFile().get(`getForApprovalListPoImportation?page=${page}&currentpage=${currentpage}&date_from=${data.dateFrom}
    &date_to=${data.dateTo}&vendor_from=${data.supplierFrom}&vendor_to=${data.supplierTo}&company=${data.company}&status=${data.status}
    &user=${data.user}&approver=${data.approver}&po_number=${data.po_number}&matnr=${data.materialno}&type=ALL`);
}

export function getApprovedPoImportation(data, page, currentpage) {
    return httpsFile().get(`getApprovedPoImportation?page=${page}&currentpage=${currentpage}&date_from=${data.dateFrom}
    &date_to=${data.dateTo}&vendor_from=${data.supplierFrom}&vendor_to=${data.supplierTo}&company=${data.company}&status=${data.status}
    &user=${data.user}&approver=${data.approver}&po_number=${data.po_number}&matnr=${data.materialno}&type=ALL`);
}

export function showPoImportation(page,currentpage,id,openFrom,forPrint = false) {
    return httpsFile().get(`showPoImportation?page=${page}&currentpage=${currentpage}&id=${id}&openFrom=${openFrom}&forPrint=${forPrint}`);
}

export function showPI(page,currentpage,id,openFrom) {
    return httpsFile().get(`showPI?page=${page}&currentpage=${currentpage}&id=${id}&openFrom=${openFrom}`);
}

export function showPIDetails(id) {
    return httpsFile().get(`showPIDetails?id=${id}`);
}

export function updatePoImportation(data) {
    return httpsFile().post(`updatePoImportation`, data);
}

export function updatePRImportation(data) {
    return httpsFile().post(`updatePRImportation`, data);
}

export function createPoImportation(data) {
    return httpsFile().post(`createPoImportation`, data);
}

export function createPI(data) {
    return httpsFile().post(`createPI`, data);
}

export function show(id) {
    return httpsFile().get(`temporary-po-header/${id}`);
}

export function update(id, data) {
    return httpsFile().post(`temporary-po-header/${id}`, data);
}

export function store(data){
    return https().post(`temporary-po-header`,data);
}

export function storeAsPR(data){
    return https().post(`savePOasPR`,data);
}

export function exportToExcel(data){
    return https().get(`exportPurchaseOrder?vendor_from=${data.supplierFrom}&vendor_to=${data.supplierTo}
            &company=${data.company}&status=${data.status}&user=${data.user}&po_number=${data.po_number}
            &matnr=${data.materialno}&date_from=${data.dateFrom}
    &date_to=${data.dateTo}`);
}